/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { poslumaTheme, borderGrey, shadow, universalStyles } from '../../../../app/theme';
import LearningCheckQuestions from '../../../micro/learningCheck/LearningCheckQuestions';
import { IMAGE_PATHS, BASE_URL } from '../../../../constants/paths.constants';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  headerImage: {
    display: 'block',
    width: '100%',
  },
  heading: {
    paddingTop: 30,
  },
  card: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'row',
    padding: '19px 71px 29px 21px',
    width: '100%',
    border: `1px solid ${borderGrey}`,
    boxShadow: `3px 3px 4px ${shadow}`,
    marginBottom: 27,
  },
  icon: {
    width: 74,
    height: 74,
  },
  cardTitleOne: {
    marginTop: 20,
    fontSize: 22,
  },
  cardTitleTwo: {
    marginTop: 10,
    fontSize: 22,
  },
  cardContent: {
    marginLeft: 17,
  },
}));

type AcquisitionPage06Props = {
  setNextDisabled: (disabled: boolean) => void;
};

const AcquisitionPage06 = ({ setNextDisabled }: AcquisitionPage06Props): JSX.Element => {
  const classes = useStyles();

  return (
    <MuiThemeProvider theme={poslumaTheme}>
      <div className={classes.poslumaBox}>
        <img
          className={classes.headerImage}
          src={`${BASE_URL}${IMAGE_PATHS.STEPS[2].ACQUISITION_STEP_2.path}`}
          alt={`${IMAGE_PATHS.STEPS[2].ACQUISITION_STEP_2.alt}`}
        />
        <div className={classes.whiteBox}>
          <Typography variant="h2">STEP 2:</Typography>
          <Typography variant="h3">Patient Preparation and Counseling</Typography>
          <Typography variant="h4" className={classes.heading}>
            Important Counseling Points for Patients
          </Typography>
          <ul className={classes.poslumaList}>
            <li>POSLUMA has no contraindications</li>
            <li>
              Adverse reactions were reported in ≥ 0.4% of subjects during clinical studies with POSLUMA. The most
              common adverse reactions were diarrhea, hypertension, and injection site pain
            </li>
            <li>
              Androgen deprivation therapy (ADT) and other therapies targeting the androgen pathway, such as androgen
              receptor antagonists, can result in changes in uptake of POSLUMA in prostate cancer
            </li>
          </ul>
          <Typography variant="h4">Instruct patients to ensure:</Typography>
          <div className={classes.card}>
            <img
              className={classes.icon}
              src={`${BASE_URL}${IMAGE_PATHS.HYDRATION_ICON.path}`}
              alt={IMAGE_PATHS.HYDRATION_ICON.alt}
            />
            <div className={classes.cardContent}>
              <Typography variant="h4" className={classes.cardTitleOne}>
                Adequate hydration prior to administration of POSLUMA
              </Typography>
            </div>
          </div>
          <div className={classes.card}>
            <img
              className={classes.icon}
              src={`${BASE_URL}${IMAGE_PATHS.POSLUMA_VOID_ICON.path}`}
              alt={IMAGE_PATHS.POSLUMA_VOID_ICON.alt}
            />
            <div className={classes.cardContent}>
              <Typography variant="h4" className={classes.cardTitleTwo}>
                Continued drinking and frequent voiding for the first few hours following administration to reduce
                radiation exposure
              </Typography>
            </div>
          </div>
        </div>
      </div>
      <LearningCheckQuestions module="poslumaAcquisition" page={6} setNextDisabled={setNextDisabled} trainingId={2} />
    </MuiThemeProvider>
  );
};

export default AcquisitionPage06;
